import { LOG_TYPES } from "./constants.js";
import { formatStatusText } from "./formatStatusText.js";
import { formatString } from "./formatString.js";

export const formatSecurityLog = ({ locales, log = {} }) => {
  const { host, item, employee, newValue, previousValue, type } = log;
  const [characterName, editedItems] = item?.split(":") || [];
  const messages = {
    [LOG_TYPES.STAT]: formatString(locales["security.logs.stat"], [
      employee?.name,
      host?.serial,
      host?.character?.name || locales["security.logs.unassigned"],
      item,
      previousValue,
      newValue,
    ]),
    [LOG_TYPES.STATUS]: formatString(locales["security.logs.stat"], [
      employee?.name,
      host?.serial,
      host?.character?.name || locales["security.logs.unassigned"],
      item,
      formatStatusText({ locales, status: previousValue }),
      formatStatusText({ locales, status: newValue }),
    ]),
    [LOG_TYPES.ASSIGN]: formatString(locales["security.logs.assign"], [
      employee?.name,
      newValue,
      host?.serial,
    ]),
    [LOG_TYPES.EDIT]: formatString(locales["security.logs.edit"], [
      employee?.name,
      host?.character?.name || characterName,
      host?.serial || locales["security.logs.unassigned"],
      editedItems?.replaceAll(",", ", ") || editedItems,
    ]),
    [LOG_TYPES.CREATE]: formatString(locales["security.logs.create"], [
      employee?.name,
      newValue,
      host?.serial || locales["security.logs.unassigned"],
    ]),
  };

  return (
    messages[type] || formatString(locales["security.logs.unknownType"], [type])
  );
};
